<template>
<div class="app">
  <v-container grid-list-md text-xs-center>
    <v-layout row wrap>  
        <v-flex xs12 sm4 md4 lg4 class="custom-box">
          <v-card>
            <v-card-title primary-title class="justify-center">
              <h2 class="text-xs-center">Price Plan 1</h2> 
            </v-card-title>
            <v-flex xs12>
               <h2 class="price text-xs-center">$100</h2> 
               <span class="small-title">When Paid Quarterly</span>
            </v-flex>
            <v-layout row wrap>     
              <v-flex sm6 mg6 lg6>
                <span class="feature-label">
                  Feature Label 1
                </span>
              </v-flex>
              <v-flex  xs6 sm6 mg6 lg6>
                  <b class="yes">YES</b>
              </v-flex>
            </v-layout>
            <v-layout row wrap>     
              <v-flex sm6 mg6 lg6>
                <span class="feature-label">
                  Feature Label 2
                </span>
              </v-flex>
              <v-flex xxs6 sm6 mg6 lg6>
                  <b class="no">NO</b>
              </v-flex>
            </v-layout>
            <v-layout row wrap>     
              <v-flex sm6 mg6 lg6>
                <span class="feature-label">
                  Feature Label 3
                </span>
              </v-flex>
              <v-flex xs6 sm6 mg6 lg6>
                  <b class="monthly">Monthly</b>
              </v-flex>
            </v-layout>
            <v-layout row wrap>     
              <v-flex xs6 sm6 mg6 lg6>
                <span class="feature-label">
                  Feature Label 2
                </span>
              </v-flex>
              <v-flex xs6 sm6 mg6 lg6>
                  <b class="no">NO</b>
              </v-flex>
            </v-layout>
            <v-layout row wrap>     
              <v-flex xs6 sm6 mg6 lg6>
                <span class="feature-label">
                  Feature Label 3
                </span>
              </v-flex>
              <v-flex xs6 sm6 mg6 lg6>
                  <b class="monthly">Monthly</b>
              </v-flex>
            </v-layout>
            <v-layout row wrap>     
              <v-flex xs6 sm6 mg6 lg6>
                <span class="feature-label">
                  Feature Label 2
                </span>
              </v-flex>
              <v-flex xs6 sm6 mg6 lg6>
                  <b class="no">NO</b>
              </v-flex>
            </v-layout>
            <v-layout row wrap>     
              <v-flex xs6 sm6 mg6 lg6>
                <span class="feature-label">
                  Feature Label 3
                </span>
              </v-flex>
              <v-flex xs6 sm6 mg6 lg6>
                  <b class="monthly">Monthly</b>
              </v-flex>
            </v-layout>

            <br/>
            <div class="text-xs-center">
              <v-btn flat round outline  align-center>Buy Now</v-btn>
           </div>
          </v-card>
        </v-flex>


        <v-flex xs12 sm4 md4 lg4>
          <v-card dark class="center-box">
            <v-card-title primary-title class="justify-center">
              <h2 class="text-xs-center">Price Plan 2</h2> 
            </v-card-title>
            <v-flex xs12>
               <h2 class="price text-xs-center">$100</h2> 
               <span class="small-title">When Paid Quarterly</span>
            </v-flex>
            <v-layout row wrap>     
              <v-flex xs6 sm6 mg6 lg6>
                <span class="feature-label">
                  Feature Label 1
                </span>
              </v-flex>
              <v-flex xs6 sm6 mg6 lg6>
                  <b class="yes">YES</b>
              </v-flex>
            </v-layout>
            <v-layout row wrap>     
              <v-flex xs6 sm6 mg6 lg6>
                <span class="feature-label">
                  Feature Label 2
                </span>
              </v-flex>
              <v-flex xs6 sm6 mg6 lg6>
                  <b class="no">NO</b>
              </v-flex>
            </v-layout>
            <v-layout row wrap>     
              <v-flex xs6 sm6 mg6 lg6>
                <span class="feature-label">
                  Feature Label 3
                </span>
              </v-flex>
              <v-flex xs6 sm6 mg6 lg6>
                  <b class="monthly">Monthly</b>
              </v-flex>
            </v-layout>
            <v-layout row wrap>     
              <v-flex xs6 sm6 mg6 lg6>
                <span class="feature-label">
                  Feature Label 2
                </span>
              </v-flex>
              <v-flex xs6 sm6 mg6 lg6>
                  <b class="no">NO</b>
              </v-flex>
            </v-layout>
            <v-layout row wrap>     
              <v-flex xs6 sm6 mg6 lg6>
                <span class="feature-label">
                  Feature Label 3
                </span>
              </v-flex>
              <v-flex xs6 sm6 mg6 lg6>
                  <b class="monthly">Monthly</b>
              </v-flex>
            </v-layout>
            <v-layout row wrap>     
              <v-flex xs6 sm6 mg6 lg6>
                <span class="feature-label">
                  Feature Label 2
                </span>
              </v-flex>
              <v-flex xs6 sm6 mg6 lg6>
                  <b class="no">NO</b>
              </v-flex>
            </v-layout>
            <v-layout row wrap>     
              <v-flex xs6 sm6 mg6 lg6>
                <span class="feature-label">
                  Feature Label 3
                </span>
              </v-flex>
              <v-flex xs6 sm6 mg6 lg6>
                  <b class="monthly">Monthly</b>
              </v-flex>
            </v-layout>
            <v-layout row wrap>     
              <v-flex xs6 sm6 mg6 lg6>
                <span class="feature-label">
                  Feature Label 2
                </span>
              </v-flex>
              <v-flex xs6 sm6 mg6 lg6>
                  <b class="no">NO</b>
              </v-flex>
            </v-layout>
            <v-layout row wrap>     
              <v-flex xs6 sm6 mg6 lg6>
                <span class="feature-label">
                  Feature Label 3
                </span>
              </v-flex>
              <v-flex xs6 sm6 mg6 lg6>
                  <b class="monthly">Monthly</b>
              </v-flex>
            </v-layout>

            <br/>
            <div class="text-xs-center">
              <v-btn align-center round class="custom-btn">Buy Now</v-btn>
           </div>
          </v-card>
        </v-flex>

        <v-flex xs12 sm4 md4 lg4 class="custom-box third-box">
          <v-card class="custom-v-card">
            <v-card-title primary-title class="justify-center">
              <h2 class="text-xs-center">Price Plan 3</h2> 
            </v-card-title>
            <v-flex xs12>
               <h2 class="price text-xs-center">$100</h2> 
               <span class="small-title">When Paid Quarterly</span>
            </v-flex>
            <v-layout row wrap>     
              <v-flex xs6 sm6 mg6 lg6>
                <span class="feature-label">
                  Feature Label 1
                </span>
              </v-flex>
              <v-flex xs6 sm6 mg6 lg6>
                  <b class="yes">YES</b>
              </v-flex>
            </v-layout>
            <v-layout row wrap>     
              <v-flex xs6 sm6 mg6 lg6>
                <span class="feature-label">
                  Feature Label 2
                </span>
              </v-flex>
              <v-flex xs6 sm6 mg6 lg6>
                  <b class="no">NO</b>
              </v-flex>
            </v-layout>
            <v-layout row wrap>     
              <v-flex xs6 sm6 mg6 lg6>
                <span class="feature-label">
                  Feature Label 3
                </span>
              </v-flex>
              <v-flex xs6 sm6 mg6 lg6>
                  <b class="monthly">Monthly</b>
              </v-flex>
            </v-layout>
            <v-layout row wrap>     
              <v-flex xs6 sm6 mg6 lg6>
                <span class="feature-label">
                  Feature Label 2
                </span>
              </v-flex>
              <v-flex xs6 sm6 mg6 lg6>
                  <b class="no">NO</b>
              </v-flex>
            </v-layout>
            <v-layout row wrap>     
              <v-flex xs6 sm6 mg6 lg6>
                <span class="feature-label">
                  Feature Label 3
                </span>
              </v-flex>
              <v-flex xs6 sm6 mg6 lg6>
                  <b class="monthly">Monthly</b>
              </v-flex>
            </v-layout>
            <v-layout row wrap>     
              <v-flex xs6 sm6 mg6 lg6>
                <span class="feature-label">
                  Feature Label 2
                </span>
              </v-flex>
              <v-flex xs6 sm6 mg6 lg6>
                  <b class="no">NO</b>
              </v-flex>
            </v-layout>
            <v-layout row wrap>     
              <v-flex xs6 sm6 mg6 lg6>
                <span class="feature-label">
                  Feature Label 3
                </span>
              </v-flex>
              <v-flex xs6 sm6 mg6 lg6>
                  <b class="monthly">Monthly</b>
              </v-flex>
            </v-layout>

            <br/>
            <div class="text-xs-center">
              <v-btn flat round color="black" outline align-center>Buy Now</v-btn>
           </div>
          </v-card>
        </v-flex>


        
  </v-layout>
  </v-container>
</div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      switch1: false,
      datas: [{},
      {}],
    }
  },
  watch: {
  },  
  methods: {

  },

}
</script>

<style>
 .price{
    color: #c23346;
  }
  .yes{
    color: #63a378;
  }
  .no{
    color: #c23346;
  }
  .small-title{
    font-size: 10px;
  }
  .v-card.theme--dark{
    background-color: #17283a !important;
  }
  .v-card{
    padding-bottom: 20px;
  }
  .custom-btn{
    background-color: #d1313d !important;
    color: white;
    font-weight: bold;
  }
  .v-card__title{
    padding-bottom:0px;
  }
  .custom-box{
    padding-top:30px !important; 
  }
  .center-box{
     outline: #17283a solid 10px;
  }
  .third-box{
     padding-left:7px !important;
  }

</style>